import type { CanDeactivateFn } from '@angular/router';

/** Implemented by components the {@link pendingChangesGuard} protects. */
export interface HasPendingChanges {
  /** True while the component holds unsaved edits. */
  hasPendingChanges(): boolean;
}

/**
 * Confirm-before-leave guard for editors with local draft state. Uses a
 * plain `confirm()` — matching the low-ceremony patterns elsewhere; a
 * styled dialog can replace it without touching consumers.
 */
export const pendingChangesGuard: CanDeactivateFn<HasPendingChanges> = (component) =>
  !component.hasPendingChanges() || confirm('You have unsaved changes. Leave without saving?');
